import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { statsConfigSelectors } from '../../../../../redux/ducks/config';
import { reportActionCreators } from '../../../../../redux/ducks/playersAndTeams/report';
import { commonMessages } from '../../../../../utility/commonMessages';

const SeasonToSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const statsConfig = useSelector((state) => state.config);
    const selectedSeasonFrom = useSelector((state) => state.playersAndTeams.report.current.seasonFrom);
    const selectedSeasonTo = useSelector((state) => state.playersAndTeams.report.current.seasonTo);

    const fromOptions = statsConfigSelectors.getSeasonsAsDropdownOptions(
        statsConfig,
        selectedSeasonFrom,
        selectedSeasonTo,
    );
    const toOptions = fromOptions.filter((obj) => obj.value >= selectedSeasonFrom);

    const handleSeasonToChange = (e, { value }) => {
        dispatch(reportActionCreators.setSeasonTo(value));
        dispatch(reportActionCreators.runReport());
    };

    return (
        <Select
            options={toOptions}
            onOptionChange={handleSeasonToChange}
            name="seasonTo"
            selectedOption={toOptions.find((obj) => obj.value === selectedSeasonTo)}
            isSearchEnabled
            dropdownButtonAriaLabel={intl.formatMessage(commonMessages.filters.expandSeason)}
            optionsBoxAriaLabel={intl.formatMessage(commonMessages.filters.seasonTo)}
        />
    );
};

export default SeasonToSelect;
